/**
 * Enum for Log level.
 * @readonly
 * @enum {number}
 */
export var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["All"] = 128] = "All";
    LogLevel[LogLevel["Activity"] = 64] = "Activity";
    LogLevel[LogLevel["Trace"] = 32] = "Trace";
    LogLevel[LogLevel["Debug"] = 16] = "Debug";
    LogLevel[LogLevel["Info"] = 8] = "Info";
    LogLevel[LogLevel["Warn"] = 4] = "Warn";
    LogLevel[LogLevel["Error"] = 2] = "Error";
    LogLevel[LogLevel["Fatal"] = 1] = "Fatal";
    LogLevel[LogLevel["Off"] = 0] = "Off";
})(LogLevel || (LogLevel = {}));
//# sourceMappingURL=LogLevel.js.map